import React from 'react';
import { useUtilityInfo } from '../../auth/hooks';
import { useGuestPortalBranding } from '../hooks';

export const AnnouncementBanner = () => {
  const tenant = localStorage.getItem('tenant');
  const utilityName = localStorage.getItem('utilityName');
  
  const { data: utilityInfo } = useUtilityInfo(
    { tenant_alias: tenant || '', utility_alias: utilityName || '' },
    { enabled: !!tenant && !!utilityName }
  );

  const utilityId = utilityInfo?.result?.id;

  const { data: brandingDataRes } = useGuestPortalBranding(
    { remote_utility_id: String(utilityId) },
    { enabled: !!utilityId }
  );

  const brandingData = brandingDataRes?.result || brandingDataRes;
  const bannerConfig = brandingData?.announcementBanner;
  
  const showBanner = bannerConfig?.announcementBanner;
  const bannerMessage = bannerConfig?.bannerMessage;
  const bannerBg = bannerConfig?.bgColour ? `#${bannerConfig.bgColour}` : '#1e2a3b';
  const bannerText = bannerConfig?.textColour ? `#${bannerConfig.textColour}` : '#d1d5db';

  if (showBanner && bannerMessage) {
    return (
      <div 
        className="text-xs py-2 text-center w-full relative z-10 font-medium shrink-0"
        style={{ backgroundColor: bannerBg, color: bannerText }}
      >
        {bannerMessage}
      </div>
    );
  }

  return null;
};
